@file:NoLiveLiterals

package com.downdogapp.client.singleton

import androidx.compose.runtime.NoLiveLiterals
import com.downdogapp.*
import com.downdogapp.client.Strings
import com.downdogapp.client.api.ProductPeriod
import com.downdogapp.client.controllers.PurchaseViewController
import kotlin.js.Promise

object PayPal {

  private fun fetch(url: String, params: Map<String, String?>): Promise<dynamic> =
    NetworkHelper
      .fetch(
        url = url,
        params = params.filterNonNullValues()
      )
      .then { it.json() }
      .then { it.asDynamic() }

  fun createSubscription(productPeriod: ProductPeriod, currencyCode: String?): Promise<String> =
    fetch(
      url = "/paypal/createSubscription",
      params = mapOf(
        "productPeriod" to productPeriod.name,
        "currencyCode" to currencyCode
      )
    )
      .then { response: dynamic ->
        return@then response["id"] as String
      }

  fun createMembership(productPeriod: ProductPeriod, currencyCode: String?, subscriptionId: String) =
    fetch(
      url = "/paypal/createMembership",
      params = mapOf(
        "productPeriod" to productPeriod.name,
        "currencyCode" to currencyCode,
        "subscriptionId" to subscriptionId
      )
    )
      .then { response: dynamic ->
        if (response["errorMessage"] != undefined) {
          App.alert(message = Strings.PAYPAL_AUTHORIZATION_ERROR_MESSAGE)
        } else {
          PurchaseViewController.onPurchaseSuccessful()
        }
      }
}